import { render, staticRenderFns } from "./QuestionMediaForm.vue?vue&type=template&id=5c3d4513&scoped=true&"
import script from "./QuestionMediaForm.vue?vue&type=script&lang=js&"
export * from "./QuestionMediaForm.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMediaForm.vue?vue&type=style&index=0&id=5c3d4513&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d4513",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VChip,VCombobox,VDivider})
